import React from 'react';
import {
  CURRENCY_MAP_ICON,
  PRICE_MAP_LABEL,
} from '../../constants/CurrencyClasses';

function DayBar({
  foundDay,
  dateFrom,
  dateTo,
  currency,
  minPrice,
  maxPrice,
  handleBarChoose,
}) {
  const { date, price, monthInfo, dateText, weekDay } = foundDay;
  const chosen = dateFrom === date || dateTo === date;
  const startOfMonth = dateText === '01';
  const barHeight = price / (maxPrice / 100);
  const pricePopupBarHeight = 100 - barHeight;
  const isCloseToMinPrice = minPrice * 1.05 > price;
  return (
    <div
      className="graph__item"
      key={date}
      title={`${date}, ${price}`}
      onClick={() => handleBarChoose(date)}
    >
      {startOfMonth ? (
        <div
          className="graph__item-month"
          style={{
            height: `calc(${pricePopupBarHeight}px + 34px)`,
          }}
        >
          {monthInfo}
        </div>
      ) : null}
      <div
        className={`graph__item-price-popup${
          chosen ? ' graph__item-price-popup_visible' : ''
        }${isCloseToMinPrice ? ' graph__item-price-popup_profitable' : ''}`}
        style={{
          transform: `translateY(${pricePopupBarHeight}px)`,
        }}
      >
        от {price}
        {CURRENCY_MAP_ICON[PRICE_MAP_LABEL[currency]]}
      </div>
      <div className="graph__item-bar-container">
        <div
          className={`graph__item-bar${
            chosen ? ' graph__item-bar_chosen' : ''
          }${isCloseToMinPrice ? ' graph__item-bar_profitable' : ''}`}
          style={{ height: `${barHeight}%` }}
        ></div>
      </div>
      <div
        className={`graph__item-labels${
          chosen ? ' graph__item-labels_chosen' : ''
        }`}
      >
        <p className="graph__item-label">{dateText}</p>
        <p className="graph__item-label">{weekDay}</p>
      </div>
    </div>
  );
}

export default DayBar;
